import { render } from "./AllRoles.vue?vue&type=template&id=756440c0&scoped=true"
import script from "./AllRoles.vue?vue&type=script&lang=js"
export * from "./AllRoles.vue?vue&type=script&lang=js"

import "./AllRoles.vue?vue&type=style&index=0&id=756440c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756440c0"]])

export default __exports__